export const AppearanceType = {
    amount: 'amount',
    checklist: 'checklist',
    radiobuttons: 'radiobuttons',
    switches: 'switches',
    textarea: 'textarea',
    single: 'single',
};
export var ProductSelectionType;
(function (ProductSelectionType) {
    ProductSelectionType["Config"] = "Config";
})(ProductSelectionType || (ProductSelectionType = {}));
export const ChangeOrderScenarios = {
    postpaid: 'postpaid',
    priceLowerBeforeCapture: 'priceLowerBeforeCapture',
    priceEqualBeforeCapture: 'priceEqualBeforeCapture',
    priceHigherAuthorizedBeforeCapture: 'priceHigherAuthorizedBeforeCapture',
    priceHigherBeforeCapture: 'priceHigherBeforeCapture',
    priceLowerAfterCapture: 'priceLowerAfterCapture',
    priceEqualAfterCapture: 'priceEqualAfterCapture',
    priceHigherAfterCapture: 'priceHigherAfterCapture',
};
export var LimitedDiscountType;
(function (LimitedDiscountType) {
    LimitedDiscountType["voucher"] = "voucher";
    LimitedDiscountType["priceRule"] = "priceRule";
})(LimitedDiscountType || (LimitedDiscountType = {}));
